var map = {
	"./bachelor-of-science-visualization-min.jpg": 8279,
	"./bachelor-of-science-visualization.jpg": 9656,
	"./game-design-and-development-min.jpg": 9876,
	"./game-design-and-development.jpg": 2715,
	"./master-of-fine-arts-visualization-min.jpg": 6486,
	"./master-of-fine-arts-visualization.jpg": 8065,
	"./master-of-science-visualization-min.jpg": 4305,
	"./master-of-science-visualization.jpg": 8648,
	"./phd-architecture-min.jpg": 6161,
	"./phd-architecture.jpg": 7788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5180;